import { render, staticRenderFns } from "./ViqMessageAssistant.vue?vue&type=template&id=c43e804e&scoped=true"
import script from "./ViqMessageAssistant.vue?vue&type=script&lang=js"
export * from "./ViqMessageAssistant.vue?vue&type=script&lang=js"
import style0 from "./ViqMessageAssistant.vue?vue&type=style&index=0&id=c43e804e&scoped=true&lang=scss"
import style1 from "./ViqMessageAssistant.vue?vue&type=style&index=1&id=c43e804e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43e804e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c43e804e')) {
      api.createRecord('c43e804e', component.options)
    } else {
      api.reload('c43e804e', component.options)
    }
    module.hot.accept("./ViqMessageAssistant.vue?vue&type=template&id=c43e804e&scoped=true", function () {
      api.rerender('c43e804e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqMessageAssistant.vue"
export default component.exports